"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const TypeScriptUtils_1 = require("../Common/TypeScriptUtils");
const LogManager_1 = require("../Log/LogManager");
const Entity_1 = require("../Common/Entity");
const ChatDefinition_1 = require("./ChatDefinition");
const ChatMessage_1 = require("./ChatMessage");
const IEventHub_1 = require("../Engine/Event/IEventHub");
const ChatEvent_1 = require("./ChatEvent");
const ChatCommand_1 = require("./ChatCommand");
const NullChatRepository_1 = require("./Port/NullChatRepository");
const NullCommandHub_1 = require("../Engine/Command/Port/NullCommandHub");
const NullEventHub_1 = require("../Engine/Event/Port/NullEventHub");
const NullChatMessageAttachmentService_1 = require("./Port/NullChatMessageAttachmentService");
const CommonBaseError_1 = require("../Common/CommonBaseError");
const RtcCommand_1 = require("../Engine/Command/RtcCommand");
const ChatMessageDto_1 = require("./Protocol/ChatMessageDto");
const ChatDto_1 = require("./Protocol/ChatDto");
const ChatMessageUtils_1 = require("./Protocol/ChatMessageUtils");
const ImmutableUtils_1 = require("../Common/ImmutableUtils");
const __1 = require("..");
class Chat extends Entity_1.Entity {
    constructor(isService, chatRepo, cmdHub, evtHub, cmas, c) {
        super(isService, Chat.logger, ChatDefinition_1.ChatCommandCategory, cmdHub, ChatDefinition_1.ChatEventCategory, evtHub);
        this._id = "";
        this._version = Chat.CurrentVersion;
        this._tempId = "";
        this._name = "";
        this._tags = [];
        // we'll use a hashset to speek up lookups and guarantee uniqueness
        this._participants = new Set();
        // 記錄每個參與者的已讀數量，每個參與者已讀後會更新上來
        this._participantReadCounts = new Map();
        this._endedFor = new Set();
        this._messages = [];
        this._createdFrom = 0;
        // 這個Chat所包含的在資料庫中ChatMessage數量
        this._totalChatMessageCount = 0;
        this._chatRepo = chatRepo;
        this._chatMessageAttachmentService = cmas;
        if (c) {
            this.id = c.id || this._id;
            this.TempId = c.TempId || this._tempId;
            this.Name = c.Name || this.Name;
            this._tags = c.Tags ? c.Tags.slice() : this._tags;
            this._participants = c.Participants ? new Set(c.Participants) : this._participants;
            this._participantReadCounts = c.ParticipantReadCounts ?
                new Map(c.ParticipantReadCounts) : this._participantReadCounts;
            this._endedFor = c.EndedFor ? new Set(c.EndedFor) : this._endedFor;
            this._messages = c.Messages ? c.Messages.slice() : this._messages;
            this._createdFrom = c.CreatedFrom || this._createdFrom;
            this._totalChatMessageCount = c.TotalChatMessageCount || this._totalChatMessageCount;
        }
        this.registerAsyncCommandHandler(ChatCommand_1.ChatCommand.ParticipantSpeak, async (rtcCmd) => this.OnParticipantSpeakCommand(rtcCmd));
        this.registerAsyncCommandHandler(ChatCommand_1.ChatCommand.ChatMessagesBefore, async (rtcCmd) => this.OnChatMessageBeforeCommand(rtcCmd));
        this.registerAsyncCommandHandler(ChatCommand_1.ChatCommand.UpdateParticipantReadCount, async (rtcCmd) => this.OnUpdateParticipantReadCountCommand(rtcCmd));
        this.registerAsyncEventHandler(ChatEvent_1.ChatEvent.ParticipantSpoke, async (evt) => this.OnParticipantSpokeEvent(evt));
        this.registerAsyncEventHandler(ChatEvent_1.ChatEvent.ParticipantReadToMessageCount, async (evt) => this.OnUpdateParticipantReadCountEvent(evt));
    }
    set id(value) { this._id = value; }
    get id() { return this._id; }
    //public set version(value: number) { this._version = value; }
    get Version() { return this._version; }
    set TempId(value) { this._tempId = value; }
    get TempId() { return this._tempId; }
    set Name(value) { this._name = value; }
    get Name() { return this._name; }
    set Tags(value) { this._tags = value; }
    get Tags() { return this._tags.slice(); }
    get Participants() { return ImmutableUtils_1.immutableSetToES6Set(immutable_1.Set(this._participants).sort().toSet()); }
    get ParticipantReadCounts() { return this._participantReadCounts; }
    get EndedFor() { return this._endedFor; }
    set Messages(value) { this._messages = value; }
    get Messages() { return this._messages; }
    get CreatedFrom() { return this._createdFrom; }
    set TotalChatMessageCount(value) { this._totalChatMessageCount = value; }
    get TotalChatMessageCount() { return this._totalChatMessageCount; }
    static NewChatWithNoSpecifiedId(participants, createdTimestamp = 0, isService = false, chatRepo, cmdHub, evtHub, cmas) {
        const tempId = this.MakeTemp1on1ChatId(immutable_1.Set(participants));
        return this.NewChatOverloadWithParticipants(tempId, participants, createdTimestamp, isService, chatRepo, cmdHub, evtHub, cmas);
    }
    static NewChatOverloadWithParticipants(id, participants, createdTimestamp = 0, isService = false, chatRepo, cmdHub, evtHub, cmas) {
        const newParticipants = immutable_1.Set(participants).sort();
        return Chat.NewChatAll(id, Chat.NO_SPECIFIED_NAME, newParticipants.first(), [], participants, createdTimestamp, isService, chatRepo, cmdHub, evtHub, cmas);
    }
    static NewChat(id, participants, createdTimestamp = 0, isService = false, chatRepo, cmdHub, evtHub, cmas) {
        const newParticipants = immutable_1.Set(participants).sort();
        return Chat.NewChatAll(id, Chat.NO_SPECIFIED_NAME, newParticipants.first(), [], participants, createdTimestamp, isService, chatRepo, cmdHub, evtHub, cmas);
    }
    static NewChatFromChatMessage(cm, participants = [], doesAcceptArbitraryId = false, isService = false, chatRepo, cmdHub, evtHub, cmas) {
        const chatId = cm.BelongToChatId;
        if (!chatId) {
            if (participants.length > 0) {
                return Chat.NewChatWithNoSpecifiedId(participants, cm.TimeStamp, isService, chatRepo, cmdHub, evtHub, cmas);
            }
            else {
                return Chat.INVALID_CHAT;
            }
        }
        if (chatId.startsWith(Chat.TEMP_ID_PREFIX)) {
            return Chat.NewChatFromEncodedId(chatId, cm.TimeStamp, isService, chatRepo, cmdHub, evtHub, cmas);
        }
        if (doesAcceptArbitraryId) {
            return Chat.NewChat(chatId, participants, cm.TimeStamp, isService, chatRepo, cmdHub, evtHub, cmas);
        }
        return Chat.INVALID_CHAT;
    }
    static NewChatFromEncodedId(encodedId, createdTimestamp = 0, isService = false, chatRepo, cmdHub, evtHub, cmas) {
        if (!encodedId)
            return Chat.INVALID_CHAT;
        const splitted = encodedId.split('-');
        const tempPrefix = splitted[0];
        const name = splitted[1];
        const participants = splitted[2] ? splitted[2].split('_') : [];
        if (splitted.length === 3) {
            // Encoded ID is 1on1 chat
            const tempId = Chat.MakeTemp1on1ChatId(immutable_1.Set(participants));
            return Chat.NewChat(tempId, participants, createdTimestamp, isService, chatRepo, cmdHub, evtHub, cmas);
        }
        const creatorUsername = splitted[3];
        const tags = splitted[4] ? splitted[4].split('_') : [];
        createdTimestamp = parseInt(splitted[5], 10);
        return Chat.NewChatAll(Chat.NO_SPECIFIED_ID, name, creatorUsername, tags, participants, createdTimestamp, isService, chatRepo, cmdHub, evtHub, cmas);
    }
    static NewChatAll(specifiedId, name, creatorName, tags, participants, createdTimestamp = 0, isService = false, chatRepo, cmdHub, evtHub, cmas) {
        if (!specifiedId && (specifiedId !== Chat.NO_SPECIFIED_ID))
            throw new ChatError(`No specifiedId`);
        if (!name && (name !== Chat.NO_SPECIFIED_NAME))
            throw new ChatError('No Chat name');
        if (!creatorName)
            throw new ChatError("creatorName should not be null or empty");
        if (!tags)
            throw new ChatError("Invalid tags");
        if (!participants)
            throw new ChatError("Invalid participants.");
        const createdFrom = (createdTimestamp > Chat.NO_SPECIFIED_CREATE_TIME) ? createdTimestamp : Date.now();
        const newParticipants = new Set(participants).add(creatorName);
        const chatName = name ? name : Chat.MakeDefualtChatName(creatorName, newParticipants, createdFrom);
        const id = (specifiedId !== Chat.NO_SPECIFIED_ID) ? specifiedId : Chat.MakeTempChatId(chatName, creatorName, tags, newParticipants, createdFrom);
        const tempId = id;
        return new Chat(isService, chatRepo, cmdHub, evtHub, cmas, {
            id: id,
            TempId: tempId,
            Name: chatName,
            Tags: tags.slice(),
            Participants: newParticipants,
            ParticipantReadCounts: Chat.GenerateInitParticipantReadCounts(newParticipants),
            CreatedFrom: createdFrom,
        });
    }
    static IsTempChatId(chatId) {
        return chatId.startsWith(Chat.TEMP_ID_PREFIX);
    }
    static MakeTemp1on1ChatId(participantNames) {
        if (participantNames.size === 0)
            throw new ChatError("No participants, can't generate temp Id.");
        const chatName = "";
        const sortedParticipantNames = participantNames.sort();
        // The rule of generating temp ID. participant names should be sorted.
        // Ex: Temp-participantName1_participantName2....
        return `${Chat.TEMP_ID_PREFIX}${chatName}-${sortedParticipantNames.join("_")}`;
    }
    static MakeTempChatId(chatName, creatorName, tags, participants, createdTimestamp) {
        const sortedParticipants = immutable_1.Set(participants).sort().toArray();
        const tagsArray = Array.from(tags);
        return `${Chat.TEMP_ID_PREFIX}${chatName}-${sortedParticipants.join("_")}-${creatorName}-${tagsArray.join("_")}-${createdTimestamp}`;
    }
    static MakeDefualtChatName(creatorUsername, participants, createdTimestamp) {
        const sortedParticipants = immutable_1.Set(participants).sort().toArray();
        return `${creatorUsername}_${sortedParticipants.join("_")}_${createdTimestamp}`;
    }
    ClearEndedFor() {
        this._endedFor = new Set();
    }
    EndFor(user) {
        this._endedFor.add(user);
        if (this._endedFor.size === this.Participants.size) {
            return true;
        }
        return false;
    }
    IsEndedFor(user) {
        return this._endedFor.has(user);
    }
    NewTextChatMessage(speakerUserName, text, dt) {
        if (!immutable_1.Set(this.Participants).contains(speakerUserName))
            throw new ChatError(`${speakerUserName} doesn't in this Chat.`);
        return Chat.NewTextChatMessage(this._isService, this._commandHub, this._eventHub, {
            belongToChatId: this.id,
            speakerUserName: speakerUserName,
            text: text,
        }, dt);
    }
    static NewTextChatMessage(isService, cmdHub, evtHub, para, dt) {
        if (!dt) {
            return new ChatMessage_1.ChatMessage(isService, cmdHub, evtHub, {
                BelongToChatId: para.belongToChatId,
                Speaker: para.speakerUserName,
                ContentType: __1.ChatMessageDefinition.CONTENT_TYPE_TEXT_PLAIN,
                Text: para.text
            });
        }
        else {
            return new ChatMessage_1.ChatMessage(isService, cmdHub, evtHub, {
                BelongToChatId: para.belongToChatId,
                Speaker: para.speakerUserName,
                ContentType: __1.ChatMessageDefinition.CONTENT_TYPE_TEXT_PLAIN,
                Text: para.text,
                TimeStamp: dt.getTime()
            });
        }
    }
    NewImageChatMessage(para) {
        if (!immutable_1.Set(this.Participants).contains(para.speakUserName))
            throw new ChatError(`${para.speakUserName} doesn't in this Chat.`);
        return Chat.NewImageChatMessage(this._isService, this._commandHub, this._eventHub, {
            belongToChatId: this.id,
            speakUserName: para.speakUserName,
            uploadFileExt: para.uploadFileExt,
            contentType: para.contentType,
            thumbnailChecker: para.thumbnailChecker,
            thumbnailSupplier: para.thumbnailSupplier,
            attachmentChecker: para.attachmentChecker,
            attachmentSupplier: para.attachmentSupplier,
        });
    }
    static NewImageChatMessage(isService, cmdHub, evtHub, para) {
        if (!ChatMessageUtils_1.ChatMessageUtils.IsContentTypeImage(para.contentType))
            throw new ChatError(`${para.contentType} is not image`);
        const attachmentName = Chat.MakeUniqueAttachmentName(para.speakUserName, para.uploadFileExt);
        return new ChatMessage_1.ChatMessage(isService, cmdHub, evtHub, {
            BelongToChatId: para.belongToChatId,
            Speaker: para.speakUserName,
            Text: attachmentName,
            ContentType: para.contentType,
            thumbnailChecker: para.thumbnailChecker,
            thumbnailSupplier: para.thumbnailSupplier,
            attachmentChecker: para.attachmentChecker,
            attachmentSupplier: para.attachmentSupplier,
        });
    }
    NewAudioChatMessage(para) {
        if (!immutable_1.Set(this.Participants).contains(para.speakUserName))
            throw new ChatError(`${para.speakUserName} doesn't in this Chat.`);
        return Chat.NewAudioChatMessage(this._isService, this._commandHub, this._eventHub, {
            belongToChatId: this.id,
            speakUserName: para.speakUserName,
            uploadFileExt: para.uploadFileExt,
            contentType: para.contentType,
            attachmentChecker: para.attachmentChecker,
            attachmentSupplier: para.attachmentSupplier,
        });
    }
    static NewAudioChatMessage(isService, cmdHub, evtHub, para) {
        if (!ChatMessageUtils_1.ChatMessageUtils.IsContentTypeAudio(para.contentType))
            throw new ChatError(`${para.contentType} is not auido`);
        const attachmentName = Chat.MakeUniqueAttachmentName(para.speakUserName, para.uploadFileExt);
        return new ChatMessage_1.ChatMessage(isService, cmdHub, evtHub, {
            BelongToChatId: para.belongToChatId,
            Speaker: para.speakUserName,
            Text: attachmentName,
            ContentType: para.contentType,
            attachmentChecker: para.attachmentChecker,
            attachmentSupplier: para.attachmentSupplier,
        });
    }
    NewChatMessageFrom(cmDto) {
        if ((cmDto.belongToChatId !== this.id) && (cmDto.belongToChatId !== this.TempId)) {
            throw new ChatError(`incoming Chat.id=${cmDto.belongToChatId} is not this chat=${this.id}`);
        }
        return Chat.NewChatMessageFrom(this._isService, this._commandHub, this._eventHub, cmDto);
    }
    static NewChatMessageFrom(isService, cmdHub, evtHub, cmDto) {
        return ChatMessage_1.ChatMessage.FromChatMessageDto(isService, cmdHub, evtHub, cmDto);
    }
    static MakeUniqueAttachmentName(speakUserName, uploadFileExt) {
        return `${speakUserName}-${Date.now()}${uploadFileExt}`;
    }
    async ParticipantSpeakAsync(cm) {
        const processedCm = this.ProcessChatMessageBeforeParticipantSpeak(cm);
        const addedCm = await this.AddChatMessageAsync(processedCm);
        if (addedCm === ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE)
            return;
        if (this._isService)
            throw new ChatError("Not Implemented.");
        else {
            await this.ParticipantSpeakClientUploadAttachmentAsync(addedCm);
            await this.ParticipantSpeakClientSendCommandAsync([addedCm]);
        }
    }
    async OnParticipantSpeakCommand(rtcCmd) {
        if (this._isService)
            throw new ChatError("Not Implemented.");
        else { }
    }
    async OnParticipantSpokeEvent(e) {
        let refTotalMsgCount = 0;
        if (this._isService)
            throw new ChatError("Not Implemented.");
        else {
            const chatIdCmDtos = e.bodyTo();
            const incommingCmDtos = chatIdCmDtos.Item3.slice().map(cmDtoObj => new ChatMessageDto_1.ChatMessageDto(cmDtoObj));
            const totalMsgCount = chatIdCmDtos.Item4;
            const needToAddCms = [];
            refTotalMsgCount = totalMsgCount;
            for (const cmDto of incommingCmDtos) {
                const existCm = await this.ChatMessageOfIdAsync(cmDto.id);
                if (existCm !== ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE) {
                    // Using existCm.BelongToChatId because Chat maybe in Temp mode.
                    cmDto.belongToChatId = existCm.BelongToChatId;
                    const cm = ChatMessage_1.ChatMessage.FromChatMessageDto(this._isService, this._commandHub, this._eventHub, cmDto);
                    // if ChatMessage exists, update it to make TimeStamp equal with remote repository.
                    await this.UpdateChatMessage(cm);
                    this._logger.debug(`Update exist ChatMessage to cm =${cm}`);
                }
                else {
                    const cm = ChatMessage_1.ChatMessage.FromChatMessageDto(this._isService, this._commandHub, this._eventHub, cmDto);
                    needToAddCms.push(cm);
                    if (cm.IsContentTypeWithAttachment()) {
                        await this._chatMessageAttachmentService.DownloadAttachment(cm, (error) => this._logger.error(`Download attachment=${cm.AttachmentName()} failed. reason=${error}`));
                    }
                }
            }
            const addedCms = await this.AddChatMessagesAsync(needToAddCms, refTotalMsgCount);
            this._logger.debug(`Chat=${this.id}.Add ${addedCms.length} ChatMessage, TotalMsgCount=${this.TotalChatMessageCount}`);
            const cmKeys = incommingCmDtos.map(cmdto => cmdto.id);
            const outCms = await this._chatRepo.LoadChatMessagesAsync(this.id, cmKeys);
            const outCmDtos = outCms.map(cm => cm.ToChatMessageDto());
            const outChatIdCmDtos = new TypeScriptUtils_1.Tuple4({
                Item1: this.id,
                Item2: this.TempId,
                Item3: outCmDtos,
                Item4: this.TotalChatMessageCount,
            });
            await this.publishEventAsync(ChatEvent_1.ChatEvent.ParticipantSpokeEvent(this.id, outChatIdCmDtos), [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    ProcessChatMessageBeforeParticipantSpeak(cm) {
        const newCm = new ChatMessage_1.ChatMessage(this._isService, this._commandHub, this._eventHub, cm);
        newCm.TimeStamp = Date.now();
        // 目前Web.Client傳過來沒有ChatMessage.Id，補上ChatMessage.Id
        if (TypeScriptUtils_1.isNullOrEmpty(newCm.id)) {
            newCm.id = ChatMessage_1.ChatMessage.GenerateId(newCm.TimeStamp, this.id, cm.Speaker);
        }
        return newCm;
    }
    async ParticipantSpeakServiceReportNewChatMessageAttachmentStatus(cm) {
        if (cm.IsContentTypeWithThumbnail()) {
            // This ChatMessage has thumbnail
            const thumbnailName = cm.ThumbnailName();
            await this._chatMessageAttachmentService.ReportNewAttachmentStatusAsync(thumbnailName);
        }
        if (cm.IsContentTypeWithAttachment()) {
            // This ChatMessage has attachment.
            const attachmentName = cm.AttachmentName();
            await this._chatMessageAttachmentService.ReportNewAttachmentStatusAsync(attachmentName);
        }
    }
    async ParticipantSpeakServicePublishParticipantSpokeEventAsync(addedCms) {
        // Send event to all
        //const speaker = addedCms.First().Speaker;
        const cmDtos = addedCms.map(cm => cm.ToChatMessageDto());
        const chatIdCmDtos = new TypeScriptUtils_1.Tuple4({
            Item1: this.id,
            Item2: this.TempId,
            Item3: cmDtos,
            Item4: this.TotalChatMessageCount,
        });
        const receivers = immutable_1.Set(this.Participants)
            //.Where(p => p != speaker)
            .map(p => {
            if (p)
                return new IEventHub_1.EventReceiver("", p);
            else
                throw new ChatError(`Invalid participant=${p}`);
        }).toArray();
        await this.publishEventAsync(ChatEvent_1.ChatEvent.ParticipantSpokeEvent(this.id, chatIdCmDtos), receivers);
    }
    async ParticipantSpeakClientUploadAttachmentAsync(cm) {
        if (cm.IsContentTypeWithAttachment()) {
            //上傳thumbnail&attachement
            await this._chatMessageAttachmentService.UploadAttachment(cm, (error) => this._logger.error(`Upload attachment=${cm.Text} failed. reason=${error}`));
        }
    }
    async ParticipantSpeakClientSendCommandAsync(cms) {
        const cmDtos = cms.map(cm => cm.ToChatMessageDto())
            .map(cmDto => {
            //TODO: Remove this block after making sure thumbnail is transferred by http.
            //if (!cmDto.HasContent()) return cmDto;
            //這時候才把Content拿出來減少AutoMapper轉換成本
            //cmDto.Content = cmDto.GetContent();
            return cmDto;
        });
        const participantSpeckCmd = ChatCommand_1.ChatCommand.ParticipantSpeakCommand(this.id, cmDtos);
        await this.sendCommandAsync(participantSpeckCmd);
    }
    async ChatMessageExists(cm) {
        return await this._chatRepo.DoesChatMessageExists(cm);
    }
    async AddChatMessageAsync(cm) {
        if (!this.CanChatMessageBeAdded(cm))
            return ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE;
        const needToBeAddedCm = this.AddChatMessageRecord(cm);
        this._totalChatMessageCount += 1;
        this.addChangeRecord(new Entity_1.ChangeRecord(Chat.TOTAL_CHATMESSAGE_COUNT_PROPERTY_NAME, Entity_1.ChangeOperation.Update, this.TotalChatMessageCount));
        await (this._chatRepo.SaveAsync(this));
        if (this._isService)
            throw new ChatError("Not Implemented.");
        return needToBeAddedCm;
    }
    async AddChatMessagesAsync(cms, refTotalMsgCount = 0) {
        const needToBeAddedCms = cms
            .filter((cm) => this.CanChatMessageBeAdded(cm))
            .map((cm) => this.AddChatMessageRecord(cm));
        if (needToBeAddedCms.length === 0) {
            this._logger.warn("No ChatMessage is added.");
        }
        const beforeCalTotalMsgCount = this.TotalChatMessageCount;
        const newTotalMsgCount = refTotalMsgCount && refTotalMsgCount > 0 ? refTotalMsgCount : this._totalChatMessageCount + needToBeAddedCms.length;
        if (newTotalMsgCount !== beforeCalTotalMsgCount) {
            this._totalChatMessageCount = newTotalMsgCount;
            this.addChangeRecord(new Entity_1.ChangeRecord(Chat.TOTAL_CHATMESSAGE_COUNT_PROPERTY_NAME, Entity_1.ChangeOperation.Update, this.TotalChatMessageCount));
        }
        await this._chatRepo.SaveAsync(this);
        if (this._isService) {
            // Server side doesn't need to preserve Messages in memory.
            throw new ChatError("Not Implemented.");
        }
        return needToBeAddedCms;
    }
    CanChatMessageBeAdded(cm) {
        if (cm == null)
            return false;
        if (TypeScriptUtils_1.isNullOrEmpty(cm.id)) {
            this._logger.error(`Incomming ChatMessage has no Id, ${cm}`);
            return false;
        }
        if (cm.TimeStamp <= 0) {
            this._logger.error(`Incomming ChatMessage has no timestamp. ${cm}`);
            return false;
        }
        if (!this.Participants.has(cm.Speaker)) {
            this._logger.error(`Chat.Participants doesn't containe ${cm.Speaker}`);
            return false;
        }
        if (this.Messages.findIndex(cmInMessages => cmInMessages.id === cm.id) !== -1) {
            this._logger.error(`The Chat already contains this ChatMessage=${cm}`);
            return false;
        }
        return true;
    }
    AddChatMessageRecord(cm) {
        const newCm = new ChatMessage_1.ChatMessage(this._isService, this._commandHub, this._eventHub, cm);
        newCm.BelongToChatId = this.id;
        this.Messages.push(newCm);
        this.addChangeRecord(new Entity_1.ChangeRecord(Chat.MESSAGES_PROPERTY_NAME, Entity_1.ChangeOperation.Add, newCm));
        return newCm;
    }
    async UpdateChatMessage(cm) {
        await this._chatRepo.UpdateChatMessage(cm);
    }
    async UpdateTotalMessageCount(count) {
        this._totalChatMessageCount = count;
        this.addChangeRecord(new Entity_1.ChangeRecord(Chat.TOTAL_CHATMESSAGE_COUNT_PROPERTY_NAME, Entity_1.ChangeOperation.Update, count));
        await this._chatRepo.SaveAsync(this);
    }
    async UpdateParticipantReadCount(participant, count) {
        const isUpdated = await this.InternalUpdateParticipantReadCountAsync(participant, count);
        if (!isUpdated)
            return;
        if (this._isService)
            throw new ChatError("Not Implemented.");
        else {
            const chatIdUsernameMsgCount = new TypeScriptUtils_1.Tuple3({
                Item1: this.id,
                Item2: participant,
                Item3: this.MessageReadCount(participant)
            });
            const updateReadCountCmd = ChatCommand_1.ChatCommand.UpdateParticipantReadCountCommand(this.id, chatIdUsernameMsgCount);
            await this.sendCommandAsync(updateReadCountCmd);
        }
    }
    async InternalUpdateParticipantReadCountAsync(participant, count) {
        if (!this.Participants.has(participant))
            return false;
        if ((count > this.TotalChatMessageCount) || count === -1) {
            count = this.TotalChatMessageCount;
        }
        const lastReadMsgCnt = this.MessageReadCount(participant);
        if (lastReadMsgCnt === count)
            return false;
        this._participantReadCounts.set(participant, count);
        this.addChangeRecord(new Entity_1.ChangeRecord(Chat.PARTICIPANT_READ_COUNT_PROPERTY_NAME, Entity_1.ChangeOperation.Update, new TypeScriptUtils_1.Tuple2({ Item1: participant, Item2: count })));
        await this._chatRepo.SaveAsync(this);
        this._logger.debug(`${participant}'s read count is updated to ${count} in chat=${this.id}`);
        return true;
    }
    async OnUpdateParticipantReadCountCommand(rtcCmd) {
        switch (rtcCmd.type) {
            case RtcCommand_1.CmdType.RequestExecute:
                const chatIdUsernameMsgCount = rtcCmd.contentTo();
                const chatId = chatIdUsernameMsgCount.Item1;
                const username = chatIdUsernameMsgCount.Item2;
                const msgCount = chatIdUsernameMsgCount.Item3;
                await this.UpdateParticipantReadCount(username, msgCount);
                break;
        }
    }
    async OnUpdateParticipantReadCountEvent(evt) {
        if (this._isService) { }
        else {
            const chatIdParticipantReadCount = evt.bodyTo();
            const chatId = chatIdParticipantReadCount.Item1;
            const participant = chatIdParticipantReadCount.Item2;
            const msgReadCount = chatIdParticipantReadCount.Item3;
            await this.InternalUpdateParticipantReadCountAsync(participant, msgReadCount);
            await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    MessageReadCount(participant) {
        if (!participant)
            return 0;
        if (!this.ParticipantReadCounts.has(participant)) {
            return 0;
        }
        return this.ParticipantReadCounts.get(participant) || 0;
    }
    UnreadMessageCount(participant) {
        const readcount = this.MessageReadCount(participant);
        const unreadcount = this._totalChatMessageCount - readcount;
        if (unreadcount >= 0) {
            return unreadcount;
        }
        else {
            this._logger.warn(`negtive unreadcount=${unreadcount}, total=${this._totalChatMessageCount}, readcount=${readcount}`);
            return 0;
        }
    }
    LastChatMessage() {
        if (this._messages.length === 0)
            return ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE;
        else
            return this._messages[this._messages.length - 1];
    }
    async ChatMessagesBeforeAsync(cm, retrieveCount) {
        if (this.TotalChatMessageCount === 0)
            return [];
        if (this._isService)
            throw new ChatError("Not Implemented.");
        else {
            if (cm !== ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE) {
                const hasEarlier = this.HasEarlierChatMessageBefore(cm);
                if (!hasEarlier) {
                    const curDt = new Date(cm.TimeStamp);
                    const chatCreatedDt = new Date(this.CreatedFrom);
                    const message = `No earlier message, because current Cm.TimeStamp=${curDt}, Chat.CreateFrom=${chatCreatedDt}`;
                    this._logger.debug(message);
                    return [];
                }
            }
            const chat = await this._chatRepo.LoadBeforeAsync(this.id, cm, retrieveCount);
            if (!chat || chat === Chat.INVALID_CHAT) {
                const message = `No Chat from ChatRepository with id=${this.id}, cm=${cm.id}, retrieveCount=${retrieveCount}`;
                this._logger.debug(message);
                return [];
            }
            if (chat.Messages.length > 0) {
                this._messages = chat.Messages;
                return chat.Messages;
            }
            // In client, client can ask service for earlier ChatMessage.
            this._logger.debug(`No ChatMessages in local, prepare to ask service.`);
            const cmDto = cm.ToChatMessageDto();
            const cmsBeforeCmd = ChatCommand_1.ChatCommand.ChatMessagesBeforeCommand(this.id, TypeScriptUtils_1.NewTuple2(cmDto, retrieveCount));
            await this.sendCommandAsync(cmsBeforeCmd);
            return [];
        }
    }
    async OnChatMessageBeforeCommand(rtcCmd) {
        if (this._isService)
            throw new ChatError("Not Implemented.");
        else {
            if (rtcCmd.type === RtcCommand_1.CmdType.ResponseAccept) {
                const content = rtcCmd.contentTo();
                const cmDtos = content.Item1;
                const queryMsgCount = content.Item2;
                if (!cmDtos) {
                    this._logger.error(`Received no ChatMessage, invalid command??`);
                    return;
                }
                await this.ImportEarlierChatMessagesAsync(cmDtos.map(cmDto => ChatMessage_1.ChatMessage.FromChatMessageDto(this._isService, this._commandHub, this._eventHub, cmDto)), queryMsgCount);
            }
        }
    }
    HasEarlierChatMessageBefore(cm) {
        if (cm == null || cm === ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE) {
            return this.TotalChatMessageCount > 0;
        }
        return (this.TotalChatMessageCount > 0) && cm.TimeStamp > this.CreatedFrom;
    }
    async ChatMessagesAfterAsync(cm, retrieveCount) {
        if (this.TotalChatMessageCount === 0)
            return [];
        if (this._isService)
            throw new ChatError("Not Implemented.");
        else {
            if (cm !== ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE) {
                const hasLater = await this.HasLaterChatMessageAfterAsync(cm);
                if (!hasLater) {
                    const curDt = new Date(cm.TimeStamp);
                    const message = `No later message, because current Cm.TimeStamp=${curDt}`;
                    this._logger.debug(message);
                    return [];
                }
            }
            const chat = await this._chatRepo.LoadAfterAsync(this.id, cm, retrieveCount);
            if (chat == null || chat === Chat.INVALID_CHAT) {
                return [];
            }
            if (chat.Messages.length > 0) {
                this._messages = chat.Messages;
                return chat.Messages;
            }
            //Not implement query later chat message from service,
            //Because there is no use case for it.
            return [];
        }
    }
    async HasLaterChatMessageAfterAsync(cm) {
        if (this.TotalChatMessageCount === 0)
            return false;
        const chat = await this._chatRepo.LoadWithSpecifiedChatMessageCountAsync(this.id, 1);
        const lastCm = chat.LastChatMessage();
        return (lastCm !== ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE) && (cm.TimeStamp < lastCm.TimeStamp);
    }
    async ChatMessageOfIdAsync(cmId) {
        const retCm = await this._chatRepo.LoadChatMessageAsync(this.id, cmId);
        return retCm;
    }
    async ImportEarlierChatMessagesAsync(prepareToImportCms, needToPublishCmCount) {
        const needToImportCms = prepareToImportCms.filter(cm => {
            if (cm.BelongToChatId !== this.id) {
                this._logger.error(`Wrong Chat.Id=${cm.BelongToChatId}`);
                return false;
            }
            return true;
        });
        const importedCms = await this.ImportChatMessageAsync(needToImportCms);
        const importedCmIds = importedCms.map(cm => cm.id);
        const loadedCms = await this._chatRepo.LoadChatMessagesAsync(this.id, importedCmIds);
        const loadedCmDtos = immutable_1.List(loadedCms.map(cm => cm.ToChatMessageDto())).takeLast(needToPublishCmCount).toArray();
        await this.publishEventAsync(ChatEvent_1.ChatEvent.EalierChatMessagesArrivedEvent(this.id, loadedCmDtos), [IEventHub_1.EventReceiver.CLIENT]);
        return importedCms;
    }
    async ImportChatMessageAsync(cms) {
        if (!cms)
            return [];
        const processedCms = cms.map(cm => {
            cm.BelongToChatId = this.id;
            return cm;
        });
        if (processedCms.length === 0)
            return [];
        const savedCms = await this._chatRepo.SaveChatMessagesAsync(this.id, processedCms);
        if (savedCms.length === 0) {
            this._logger.warn(`No ChatMessage is imported, something wrong?`);
            return [];
        }
        // No need to import meesage to current Chat.Messages,
        // because Chat.Messages doesn't present all ChatMessage in Chat.
        // const afterImportedMessages = List<ChatMessage>(this.Messages).concat(savedCms).sort((cmA, cmB) => cmA.TimeStamp - cmB.TimeStamp).toArray();
        // this._messages = afterImportedMessages;
        this._logger.debug(`Imported ${savedCms.length} ChatMessage.`);
        // Download attachment
        for (const savedCm of savedCms) {
            if (savedCm.IsContentTypeWithAttachment()) {
                await this._chatMessageAttachmentService.DownloadAttachment(savedCm, (error) => this._logger.error(`Download attachment=${savedCm.Text} failed, reason=${error}`));
            }
        }
        return savedCms;
    }
    async AppendChatMessageAsync(cms, totalChatMessageCount) {
        if (this._isService)
            throw new ChatError("Not Implemented.");
        else {
            for (const cm of cms) {
                await this.AddChatMessageAsync(cm);
                //下載Attachment
                if (cm.IsContentTypeWithAttachment()) {
                    await this._chatMessageAttachmentService.DownloadAttachment(cm, (error) => this._logger.error(`Download attachment=${cm.AttachmentName()} failed, reason=${error}`));
                }
                //送Event出去
                const cmDtos = [cm].map(cmParam => cmParam.ToChatMessageDto());
                const chatIdCmDtos = new TypeScriptUtils_1.Tuple4({
                    Item1: this.id,
                    Item2: this.TempId,
                    Item3: cmDtos,
                    Item4: this.TotalChatMessageCount,
                });
                await this.publishEventAsync(ChatEvent_1.ChatEvent.ParticipantSpokeEvent(this.id, chatIdCmDtos), [IEventHub_1.EventReceiver.CLIENT]);
            }
            if (this.TotalChatMessageCount !== totalChatMessageCount) {
                this._logger.warn(`ChatMessage總量需校正Chat.TotalChatMessageCount, local=${this.TotalChatMessageCount}, remote=${totalChatMessageCount}`);
                await this.UpdateTotalMessageCount(totalChatMessageCount);
            }
        }
    }
    // Hard to write test, it indicates this function should not be here.
    async CompleteReplaceChatAsync(oldChat) {
        if (oldChat === Chat.INVALID_CHAT)
            throw new ChatError("Invalid Chat.");
        if (this._isService)
            throw new ChatError("Not Implemented.");
        else {
            await this.ImportChatMessageAsync(oldChat.Messages);
            //替換之前Temp的Chat，等同本地端有新的Chat，往UI層通知
            const replacedChat = await this._chatRepo.LoadWithSpecifiedChatMessageCountAsync(this.id, 1);
            if (replacedChat !== Chat.INVALID_CHAT) {
                const replacedChatDto = replacedChat.ToChatDto();
                await this.publishEventAsync(ChatEvent_1.ChatEvent.NewChatIsCreatedEvent(replacedChatDto), [IEventHub_1.EventReceiver.CLIENT]);
            }
        }
    }
    async DownloadAttachmentsAsync() {
        const needToDownloadCms = this.Messages.filter(cm => cm.IsContentTypeWithAttachment());
        for (const needToDownloadCm of needToDownloadCms) {
            await this._chatMessageAttachmentService.DownloadAttachment(needToDownloadCm, (error) => this._logger.error(`Download attachment=${needToDownloadCm.Text} failed, reason=${error}`));
        }
    }
    static GenerateInitParticipantReadCounts(participants) {
        const prc = new Map();
        const participantsArray = immutable_1.Set(participants).toArray();
        for (const p of participantsArray) {
            prc.set(p, 0);
        }
        return prc;
    }
    ToChatDto() {
        if (this === Chat.INVALID_CHAT)
            return ChatDto_1.ChatDto.INVALID_CHAT;
        return new ChatDto_1.ChatDto({
            id: this.id,
            tempId: this.TempId,
            name: this.Name,
            tags: this.Tags,
            participants: new Set(this.Participants),
            participantReadCounts: new Map(this.ParticipantReadCounts),
            endedFor: new Set(this.EndedFor),
            messages: this.Messages.map(cm => cm.ToChatMessageDto()),
            createdFrom: this.CreatedFrom,
            totalChatMessageCount: this.TotalChatMessageCount,
        });
    }
}
Chat.logger = LogManager_1.logManager.GetLogger("Chat");
Chat.CurrentVersion = ChatDefinition_1.ChatVersion;
Chat.PARTICIPANT_READ_COUNT_PROPERTY_NAME = "participantReadCounts";
Chat.MESSAGES_PROPERTY_NAME = "messages";
Chat.TOTAL_CHATMESSAGE_COUNT_PROPERTY_NAME = "totalChatMessageCount";
Chat.INVALID_CHAT = new Chat(false, new NullChatRepository_1.NullChatRepository(), new NullCommandHub_1.NullCommandHub(), new NullEventHub_1.NullEventHub(), new NullChatMessageAttachmentService_1.NullChatMessageAttachmentService());
Chat.NO_SPECIFIED_ID = "";
Chat.NO_SPECIFIED_NAME = "";
Chat.NO_SPECIFIED_CREATE_TIME = 0;
Chat.TEMP_ID_PREFIX = "Temp-";
exports.Chat = Chat;
exports.ChatErrorName = "ChatError";
class ChatError extends CommonBaseError_1.CommonBaseError {
}
exports.ChatError = ChatError;
//# sourceMappingURL=Chat.js.map